import { render, staticRenderFns } from "./AddressFormModal.vue?vue&type=template&id=8b521390&scoped=true"
import script from "./AddressFormModal.vue?vue&type=script&lang=js"
export * from "./AddressFormModal.vue?vue&type=script&lang=js"
import style0 from "./AddressFormModal.vue?vue&type=style&index=0&id=8b521390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b521390",
  null
  
)

export default component.exports